import React from "react";
import { useRecordContext } from "react-admin";

import { ValueChip } from "./ValueChip";

export const ProductArticleReferenceField = ({ source, companyId, ...rest }) => {
	const record = useRecordContext();
	const displayValue = record?.[source];
	const productArticleId = record?.product_article_id;
	if (!displayValue || !companyId || !productArticleId) return null;
	const filter = encodeURIComponent(JSON.stringify({ id: [productArticleId] }));
	const href = `#/customer-companies/${companyId}/product-articles?filter=${filter}`;
	return <ValueChip value={displayValue} link={href} chipStyle={{ color: "#3f51b5" }} />;
};
